var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "controllable-popper" }, [_c('div', { ref: "popper", staticClass: "popper" }, [_vm._t("default")], 2), _vm._v(" "), _c('span', { ref: "wrapper", staticClass: "reference-wrapper" }, [_vm._t("reference", null, { "show": _vm.show, "hide": _vm.hide })], 2)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };